const header = document.querySelector('[data-header]');
const sections = document.querySelectorAll('[data-section]');
const headerLinks = Array.from(header.querySelectorAll('a'));

function hugues() {
  const scrollPos = window.scrollY;

  if(scrollPos > 50) {
    header.classList.add('header--scrolled');
  } else {
    header.classList.remove("header--scrolled");
  }
}

window.addEventListener('scroll', hugues, { passive: true})

const observer = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        headerLinks.forEach(link => {
          link.classList.remove("header-nav__link--active");
        });
        const section = entry.target.dataset.section;
        const currentLink = headerLinks.find(link => {
          return link.dataset.sectionHighlight == section;
        });
        if(currentLink) {
          currentLink.classList.add("header-nav__link--active");
        }
      }
    });
  },
  {
    threshold: .1
  }
);

sections.forEach(section => {
  observer.observe(section);
});